// One width for the header and the opening of each main page, so their left
// edges line up (the logo, the breadcrumbs and the headline start at the same point).
export const WIDE_CONTAINER = 'mx-auto w-full max-w-[1500px] px-4 sm:px-6 lg:px-8'
